let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i8Zoh")).then(() => parcelRequire('aWG9Z'));